import Vue from 'vue';
import Router from 'vue-router';
import AdminTools from './views/admin-tools';
import BatchIndex from './views/batch';
import DashboardIndex from './views/dashboard';
import Error404 from './errors/Error404';
import HelpIndex from './views/help';
import FulfillmentIndex from './views/fulfillment';
import FulfillmentReady from './views/fulfillment/ready';
import FulfillmentPrinted from './views/fulfillment/printed';
import FulfillmentFailed from './views/fulfillment/failed';
import FulfillmentReview from './views/fulfillment/review';
import FulfillmentSearch from './views/fulfillment/search';
import AppraisalsIndex from './views/appraisals/index';
import AppraisalsScan from './views/appraisals/scan';
import AppraisalsProcess from './views/appraisals/process';
import AppraisalsAppraise from './views/appraisals/appraise';
import AppraisalsBagging from './views/appraisals/bagging';
import AppraisalsNotFound from './views/appraisals/not-found';
import IntakeIndex from './views/intake';
import IntakeView from './views/intake/view';
import IntakeScan from './views/intake/scan';
import IntakeReceived from './views/intake/received';
import IntakeOutstanding from './views/intake/outstanding';
import IntakeNotFound from './views/intake/not-found';
import OfferGenerationIndex from './views/offer-generation/index';
import OfferGenerationView from './views/offer-generation/view';
import OfferGenerationScan from './views/offer-generation/scan';
import QualityAssuranceIndex from './views/quality-assurance/index';
import QualityAssuranceScan from './views/quality-assurance/scan';
import QualityAssuranceView from './views/quality-assurance/view';
import QualityAssuranceNotFound from './views/quality-assurance/not-found';
import KitViewIndex from './views/kits-view/index';
import KitViewNotFound from './views/kits-view/not-found';
import PaymentsIndex from './views/payments';
import PaymentsList from './views/payments/list';
import InventoryIndex from './views/inventory';
import InventoryScan from './views/inventory/scan';
import InventoryList from './views/inventory/list';
import ProfileIndex from './views/profile';
import ProfileView from './views/profile/view';
import ProfileSettings from './views/profile/settings';
import RatesTableIndex from './views/settings/rates/index';
import FulfillmentCentersView from './views/settings/fulfillment-centers';
import PricingIndex from './views/pricing';
import CoinPricingView from './views/pricing/coin-pricing';
import DiamondPricingView from './views/pricing/diamond-pricing';
import ReturnsIndex from './views/returns';
import ReturnsView from './views/returns/view';
import ReturnsNotFound from './views/returns/not-found';
import ReturnsScan from './views/returns/scan';
import SearchIndex from './views/search';
import ComplianceFlagSelect from './views/flags/search/compliance';
import SettingsIndex from './views/settings';

import UsersList from './views/settings/user/usersList';
import UserView from './views/settings/user/user';
import UserPermissions from './views/settings/user/permissions';
import reports from './views/reports';

import Login from './views/login';
import store from './store';
import {AUTH_LOGOUT} from './store/actions';
import DefaultContainer from './containers/DefaultContainer';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/');
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/login');
};

export default new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            redirect: '/dashboard',
            name: 'home',
            component: DefaultContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard-index',
                    component: DashboardIndex,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'fulfillment',
                    name: 'fulfillment-index',
                    redirect: 'fulfillment/ready',
                    component: FulfillmentIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: 'ready',
                            name: 'fulfillment-ready',
                            component: FulfillmentReady,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'printed',
                            name: 'fulfillment-printed',
                            component: FulfillmentPrinted,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'failed',
                            name: 'fulfillment-failed',
                            component: FulfillmentFailed,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'review',
                            name: 'fulfillment-review',
                            component: FulfillmentReview,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'search',
                            name: 'fulfillment-search',
                            component: FulfillmentSearch,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'intake',
                    component: IntakeIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'intake-scan',
                            component: IntakeScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'view/:id',
                            name: 'intake-view',
                            component: IntakeView,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'received',
                            name: 'intake-received',
                            component: IntakeReceived,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'outstanding',
                            name: 'intake-outstanding',
                            component: IntakeOutstanding,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'not-found/:tracking_number?',
                            name: 'intake-not-found',
                            component: IntakeNotFound,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'appraisals',
                    component: AppraisalsIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'appraisals-scan',
                            component: AppraisalsScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'process/:id',
                            name: 'appraisals-process',
                            component: AppraisalsProcess,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'appraise/:id/:inventory?/:item_id?',
                            name: 'appraisals-appraise',
                            component: AppraisalsAppraise,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'bagging/:id',
                            name: 'appraisals-bagging',
                            component: AppraisalsBagging,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'not-found/:id',
                            name: 'appraisals-not',
                            component: AppraisalsNotFound,
                            beforeEnter: ifAuthenticated,
                        }
                    ],
                },

                {
                    path: 'offer-generation',
                    component: OfferGenerationIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'offer-generation-scan',
                            component: OfferGenerationScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'view/:id',
                            name: 'offer-generation-view',
                            component: OfferGenerationView,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'kit/view/',
                    name: 'kits-view-not-found',
                    component: KitViewNotFound,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'kit/view/:id',
                    name: 'kit-view-index',
                    component: KitViewIndex,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'payments',
                    name: 'payments-index',
                    redirect: 'payments/pre-approved',
                    component: PaymentsIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: ':status/:method?',
                            name: 'payments-view',
                            component: PaymentsList,
                        }
                    ]
                },
                {
                    path: 'inventory',
                    //name: 'inventory-index',
                    component: InventoryIndex,
                    // beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'inventory-scan',
                            component: InventoryScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: ':status/:method?',
                            name: 'inventory-view',
                            component: InventoryList,
                        }
                    ]
                },
                {
                    path: 'returns',
                    component: ReturnsIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'returns-scan',
                            component: ReturnsScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'view/:id',
                            name: 'returns-view',
                            component: ReturnsView,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'not-found/:id',
                            name: 'returns-not-found',
                            component: ReturnsNotFound,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'quality-assurance',
                    component: QualityAssuranceIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'quality-assurance-scan',
                            component: QualityAssuranceScan,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'view/:id',
                            name: 'quality-assurance-view',
                            component: QualityAssuranceView,
                            beforeEnter: ifAuthenticated //qa-not-found
                        },
                        {
                            path: 'not-found/:id',
                            name: 'qa-not-found',
                            component: QualityAssuranceNotFound,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {

                    path: 'admin-tools',
                    name: 'admintools-index',
                    component: AdminTools,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'batch',
                    name: 'batch-index',
                    component: BatchIndex,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'reports',
                    name: 'reports-index',
                    component: reports,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'search',
                    name: 'search-index',
                    component: SearchIndex,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'flags/compliance',
                    name: 'flags-compliance',
                    component: ComplianceFlagSelect,
                    beforeEnter: ifAuthenticated,
                },
                {
                    path: 'profile',
                    component: ProfileIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: '',
                            name: 'profile-view',
                            component: ProfileView,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'settings',
                            name: 'profile-settings',
                            component: ProfileSettings,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'pricing',
                    name: 'pricing-index',
                    component: PricingIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: 'coin-pricing',
                            name: 'coin-pricing-view',
                            component: CoinPricingView,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'diamond-pricing',
                            name: 'diamond-pricing-view',
                            component: DiamondPricingView,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'settings',
                    name: 'settings-index',
                    component: SettingsIndex,
                    beforeEnter: ifAuthenticated,
                    children: [
                        {
                            path: 'rates',
                            name: 'rates-table-index',
                            component: RatesTableIndex,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'users',
                            name: 'settings-user-list',
                            component: UsersList,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'user/:id',
                            name: 'settings-user-view',
                            component: UserView,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'permissions',
                            name: 'permissions',
                            component: UserPermissions,
                            beforeEnter: ifAuthenticated,
                        },
                        {
                            path: 'fulfillment',
                            name: 'fulfillment-centers-view',
                            component: FulfillmentCentersView,
                            beforeEnter: ifAuthenticated,
                        },
                    ],
                },
                {
                    path: 'help',
                    name: 'help-index',
                    component: HelpIndex,
                    beforeEnter: ifAuthenticated,
                },
            ],
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter(to, from, next) {
                store.dispatch(AUTH_LOGOUT).finally(() => {next({name: 'login'}); })
                    .catch((e) => {});
            }
        },
        {
            path: '*',
            component: Error404,
        },
    ],
});
